module.exports = {"outlet":"Station Staff"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/staff.php
// module id = YfNM
// module chunks = 113